module.exports = __webpack_public_path__ + "static/media/nb.f205a92b.mp4";